import { create } from "zustand";

export type ModalType =
  | "TOKEN"
  | "COPY_ERROR"
  | "CONFIRMATION"
  | "INVITE"
  | "UNSUBSCRIBE_FLOW"
  | "ADMIN_SWITCH_USER"
  | "TOP_UP_BALANCE";

export interface ModalProps {
  TOKEN: {
    onTokenAdded?: ((supplierId: string) => void) | null;
  };
  COPY_ERROR: {
    textToCopy: string;
  };
  CONFIRMATION: {
    message: string;
    onConfirm: () => void | Promise<void>;
    isLoading?: boolean;
  };
  INVITE: object;
  UNSUBSCRIBE_FLOW: {
    onConfirm: (
      feedback: { question: string; answer: string }[],
    ) => Promise<void>;
    isLoading?: boolean;
  };
  ADMIN_SWITCH_USER: object;
  TOP_UP_BALANCE: {
    initialState?:
      | "default"
      | "loading"
      | "success-card"
      | "error-topup"
      | "error-card-exists";
  };
}

interface UiState {
  isMasked: boolean;
  toggleMask: () => void;
  activeModal: ModalType | null;
  modalProps: Partial<ModalProps[keyof ModalProps]>;
  openModal: <T extends ModalType>(modal: T, props: ModalProps[T]) => void;
  updateModalProps: (props: Partial<UiState["modalProps"]>) => void;
  closeModal: () => void;
}

const SCROLL_LOCK_CLASS = "body-scroll-locked";

export const useUiStore = create<UiState>((set, get) => ({
  isMasked: false,
  toggleMask: () => set((state) => ({ isMasked: !state.isMasked })),

  activeModal: null,
  modalProps: {},

  openModal: (modal, props) => {
    if (get().activeModal) {
      return;
    }
    document.body.classList.add(SCROLL_LOCK_CLASS);
    set({
      activeModal: modal,
      modalProps: props || {},
    });
  },

  updateModalProps: (props) => {
    set((state) => ({
      modalProps: { ...state.modalProps, ...props },
    }));
  },

  closeModal: () => {
    document.body.classList.remove(SCROLL_LOCK_CLASS);
    set({
      activeModal: null,
      modalProps: {},
    });
  },
}));
